
//@info This hook is used to debounce the search query
import { useEffect, useMemo } from "react";
import debounce from "lodash/debounce";
const useSearch = (callback, delay = 300) => {
    const debouncedCallback = useMemo(
        () => debounce(callback, delay),
        [callback, delay]
    );

    useEffect(() => {
        return () => {
            debouncedCallback.cancel();
        };
    }, [debouncedCallback]);

    return debouncedCallback;
};

export default useSearch;